export const PERSONAL_MESSAGE_MAX_CHARS_LIMIT = 1450;
